import { lazy, type ComponentType } from "react";
import i18n from "@/app/i18n";

export function lazyPage(factory: () => Promise<{ default: ComponentType }>, namespaces: string[]) {
  return lazy(function loadPage() {
    return Promise.all([factory(), i18n.loadNamespaces(namespaces).catch(function ignoreMissingNamespace() {})]).then(
      function takeModule(results) {
        return results[0];
      },
    );
  });
}
